import React from 'react';
import { Grid } from '@mui/material';
import { gql, useQuery } from '@apollo/client';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import ViewDansFundQuestionnaire
  from '../../../components/Global/DansFundQuestionnaire/View';

const GET_ALL_QUESTIONNAIRES = gql`
  query GetAllQuestionnaires {
    dans_fund_questionnaire(limit: 1) {
      id
      name
      questions
    }
  }
`;

const OrganisationDansFundQuestionnaire = (): React.ReactElement => {
  const {
    data,
    loading,
    error,
  } = useQuery(GET_ALL_QUESTIONNAIRES, { fetchPolicy: 'no-cache' });


  return (
    <DashboardLayout
      title="Dan's Fund Questionnaire"
      breadcrumbs={[{
        label: 'Home',
        link: '/org/home',
      }, { label: 'Dan\'s Fund Questionnaire' }]}
    >
      <Grid container spacing={2}>
        {/*<Grid item xs={12} style={{ textAlign: 'right', marginBottom: '16px' }}>*/}
        {/*  <Button*/}
        {/*    variant="contained"*/}
        {/*    color="primary"*/}
        {/*    startIcon={<EditIcon />}*/}
        {/*    onClick={handleEdit}*/}
        {/*  >*/}
        {/*    Edit Questionnaire*/}
        {/*  </Button>*/}
        {/*</Grid>*/}
        <Grid item xs={12}>
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div>Error loading questionnaire</div>
          ) : data?.dans_fund_questionnaire?.[0] ? (
            <ViewDansFundQuestionnaire
              questionnaireId={data.dans_fund_questionnaire[0].id} />
          ) : (
            <div>No questionnaire available</div>
          )}
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default OrganisationDansFundQuestionnaire;
